const reducer = (state: WtrState, action: { payload: { slotId: string | null } }) => ({
  ...state,
  bookingSlotId: action.payload.slotId,
  error: null,
});

export default reducer;
